import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CircleChart from 'Components/UI/Chart/CircleChart';
import DonutChart from './DonutChart';

const styles = {
  root: {},
  wrapper: {},
};

function HoldingsVisualization({ className, classes, portfolio }) {
  return (
    <CircleChart
      ChartComponent={DonutChart}
      ChartProps={{ holdings: portfolio }}
      showSkeleton={!portfolio}
      className={className}
      classes={classes}
    />
  );
}

HoldingsVisualization.propTypes = {
  portfolio: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

HoldingsVisualization.defaultProps = {
  className: '',
};
export default withStyles(styles)(HoldingsVisualization);
